/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
const paramsToRemove = ['pr_prod_strat', 'pr_rec_id', 'pr_ref_pid', 'pr_rec_pid', 'pr_seq'];

function cleanLinks(root) {
  (root || document).querySelectorAll('a[href]').forEach(a => {
    try {
      const url = new URL(a.href);
      let changed = false;
      paramsToRemove.forEach(p => {
        if (url.searchParams.has(p)) { url.searchParams.delete(p); changed = true; }
      });
      if (changed) a.href = url.toString();
    } catch(e) {}
  });
}

document.addEventListener('DOMContentLoaded', () => {
  cleanLinks();

  // Replace h1.logo with div to avoid duplicate H1 SEO issues
  const logo = document.querySelector('h1.logo');
  if (logo) {
    const div = document.createElement('div');
    logo.getAttributeNames().forEach(attr => div.setAttribute(attr, logo.getAttribute(attr)));
    div.innerHTML = logo.innerHTML;
    logo.parentNode.replaceChild(div, logo);
  }

  // Convert all H1s except the first one to H2
  const allH1s = document.querySelectorAll('h1');
  let firstFound = false;
  allH1s.forEach(h1 => {
    if (!firstFound) {
      firstFound = true;
      return;
    }
    const h2 = document.createElement('h2');
    h1.getAttributeNames().forEach(attr => h2.setAttribute(attr, h1.getAttribute(attr)));
    h2.innerHTML = h1.innerHTML;
    h1.parentNode.replaceChild(h2, h1);
  });
});

const observer = new MutationObserver(mutations => {
  mutations.forEach(m => m.addedNodes.forEach(node => {
    if (node.nodeType === 1) cleanLinks(node);
  }));
});

observer.observe(document.body, { childList: true, subtree: true });

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('h2[id^="country-heading-"]').forEach(function(el) {
    el.remove();
  });
});

(function() {
  // Add custom code below this line

  // Zepto price sync: sincroniza el precio del botón con el precio de arriba
  // Usa polling en vez de MutationObserver porque el precio de Zepto
  // no dispara mutaciones detectables de forma fiable.
  document.addEventListener('DOMContentLoaded', function () {

    function getVisible(selector) {
      const els = document.querySelectorAll(selector);
      for (const el of els) {
        if (el.offsetParent !== null) return el;
      }
      return null;
    }

    let lastText = '';

    function syncButtonPrice() {
      const priceSource = getVisible('div.product__price');
      if (!priceSource) return;

      // Precio del botón (nunca el de arriba, para no copiar el precio dentro de sí mismo)
      const priceButton = Array.from(document.querySelectorAll('[name="add"] span.product__price--regular'))
        .find(function (el) { return el.offsetParent !== null && !priceSource.contains(el); });
      if (!priceButton) return;

      const activeEl = priceSource.querySelector('.price-item--sale')
        || priceSource.querySelector('.price-item--regular')
        || priceSource.querySelector('[data-product-price]')
        || priceSource;

      const text = activeEl.innerText.trim().replace(/\s*EUR\s*/i, '').trim();

      if (text && text !== lastText) {
        priceButton.innerText = text;
        lastText = text;
      }
    }

    // Sincroniza ya al cargar
    syncButtonPrice();

    // Comprueba cada 400ms si el precio ha cambiado
    setInterval(syncButtonPrice, 400);
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

/* EVF: aviso si falta un campo obligatorio de personalización al añadir al carrito */
(function () {
  function emptyRequired() {
    return Array.prototype.slice.call(document.querySelectorAll('[name^="properties["][required]'))
      .filter(function (el) {
        return el.type !== 'hidden' && el.type !== 'file' && el.offsetParent !== null && !String(el.value || '').trim();
      });
  }
  function showMsg(el) {
    var id = 'evf-req-msg';
    var old = document.getElementById(id);
    if (old) old.remove();
    var msg = document.createElement('p');
    msg.id = id;
    msg.setAttribute('role', 'alert');
    msg.textContent = /nombre/i.test(el.name || '') ? 'Escribe el nombre para personalizar tu regalo' : 'Completa este campo para personalizar tu regalo';
    msg.style.cssText = 'display:block;width:100%;color:#c0392b;font-size:14px;margin:6px 0 10px;';
    (el.parentElement || el).insertAdjacentElement('afterend', msg);
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () { try { el.focus({ preventScroll: true }); } catch (e) {} }, 450);
    el.addEventListener('input', function () { var m = document.getElementById(id); if (m) m.remove(); }, { once: true });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button[name="add"]');
    if (!btn) return;
    var empties = emptyRequired();
    if (!empties.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    showMsg(empties[0]);
  }, true);
})();
